import styled from "styled-components"
import { Title1 } from "styles/business-components"

export const Backdrop = styled.div`
  z-index: 300;
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  display: flex;
  background-color: rgba(0, 0, 0, 0.5);
`

export const Title = styled(Title1)`
  text-align: center;
  margin-bottom: 0;
`

export const Buttons = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`

export const FormInput = styled.input`
  width: 100%;
  padding: 20px;
  border-radius: 20px;
  background: ${({theme}) => theme.business.colors.feedbackFormInputBackground};
  color: ${({theme}) => theme.business.colors.textColor};
  border: ${({theme}) => `1px solid ${theme.business.colors.feedbackFormInputBorder}`};
  font-size: 22px;
`

export const FormTextarea = styled.textarea`
  resize: none;
  width: 100%;
  padding: 20px;
  border-radius: 20px;
  background: ${({theme}) => theme.business.colors.feedbackFormInputBackground};
  color: ${({theme}) => theme.business.colors.textColor};
  border: ${({theme}) => `1px solid ${theme.business.colors.feedbackFormInputBorder}`};
  font-size: 22px;
  font-family: ${({theme}) => theme.font.family};
`
